module.exports = __webpack_public_path__ + "static/crazy_rich_asians_1920x900-mobile.6cb6bf47.png";